import { connect } from 'react-redux';

import SubmenuItem from './desktop.submenu.submenu_item.jsx';

import { getATagProps } from 'zoomforth_codesbane_viewer/lib/app_actions.js';
import {
  executeMatchedRouteIfSameHashOnMenuItemClick
} from 'zoomforth_codesbane_viewer/lib/backbone_history_utils.js';
import { getTracker } from 'zoomforth_codesbane_viewer/lib/global_store.js';

const mapStateToProps = (state, ownProps) => {
  const { submenuItem, currentSubpage, lastClickedSubmenuItemId } = ownProps;

  const selected = (
    lastClickedSubmenuItemId &&
    submenuItem.appAction.subpageId === currentSubpage.id &&
    lastClickedSubmenuItemId === submenuItem.id
  );

  const title = submenuItem.title;

  const { href, target } = getATagProps(submenuItem.appAction);

  return {
    href,
    target,
    selected,
    title
  };
};

const mapDispatchToProps = (dispatch, { submenuItem }) => ({
  onATagClick: ()=> { 
    getTracker().handleNavMenuItemClick(submenuItem);
    executeMatchedRouteIfSameHashOnMenuItemClick(submenuItem);
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SubmenuItem);
